<style>
	.summary-organ-select-ul li{
		background: none !important;
		overflow: hidden;
	}
	.summary-organ-select-ul li label{
		display: block;
		position: relative;
	}
	.summary-organ-select-ul li label input[type="radio"]{
		position: absolute;
		top: -20px;
		right: 15px;
	}
	.summary-organ-select-ul li label input[type="radio"]:checked:before{
		content: url(../assets/allorderbill/radio-check.png);
		position: absolute;
		top:28px;
	}
	.summary-filter-p{
		margin: .3em 1em;
	}
</style>
<template>
<div>
<transition name="slide">
	<div v-show="show" class="summary-wrapper">
		<navbar title="货品汇总-选择机构"></navbar>
		<w-search
			v-show="true"
			v-model="searchKey"
			placeholder="可搜索门店编号、名称、助记符"
			:showFilterBtn="false"
			@on-serch="onSearch"
		></w-search>
		<div class="summary-filter-shell" style="background:none">
			<div v-for = "(organDetail, index) in organDetails">
				<p class="summary-filter-p">{{organDetail.phonetic}}</p>
				<ul class="summary-filter-ul summary-organ-select-ul">
					<li @click="selectOrgan(organDetail.organId,organDetail.name)">
						<label>{{organDetail.name}}
							<input type="radio" name="selectOrgan" v-if="selectJudge(organDetail.organId)" checked>
							<input type="radio" name="selectOrgan" v-else>
						</label>
					</li>
				</ul>
			</div>
		</div>
	</div>
</transition>
</div>
</template>
<script>
import NavBar from '../components/NavBar'
export default {
	props: {
		selectedId: String,
		selectedName: String,
		restaurantId: String
	},
	data () {
		return {
			show: false,
			organDetails: [],
			searchKey: ''
		}
	},
	components: {
		'navbar': NavBar
	},
	created () {
		// this.organLoad()
	},
	methods: {
		selectJudge (val) {
			if (this.selectedId === val) {
				return true
			} else {
				return false
			}
		},
		open (a) {
			var arrTemp = [{
				create_time: null,
				enable_flag: true,
				id: -1,
				modify_time: null,
				name: '全部机构',
				organId: '',
				phonetic: 'QBJG'
			}]
			a.forEach(function (one) {
				arrTemp.push(one)
			})
			this.show = !this.show
			this.organDetails = arrTemp
			// window.console.log(this.selectedId + ',' + this.selectedName)
		},
		selectOrgan (id, name) {
			this.show = false
			var str = id + '|' + name
			this.$emit('selectOrgan', str)
		},
		onSearch () {
			this.$http.get('/cldEdi/business/getShopList.do?restraurantId=' + this.restaurantId + '&keyword=' + this.searchKey).then(res => {
				var arrTemp = [{
					create_time: null,
					enable_flag: true,
					id: -1,
					modify_time: null,
					name: '全部机构',
					organId: '',
					phonetic: 'QBJG'
				}]
				this.organDetails = [...arrTemp, ...res.body.data]
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// OrganSelect.vue?48f13bc8